import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { OAuthApplication } from "../../auth";

interface IProps {
  status?: string;
  count?: number;
  name?: string;
  ownedBy?: string;
}

export async function GetInsurancePlan({
  status,
  count,
  name,
  ownedBy,
}: IProps) {
  // Construir URL base
  let url = `${endpoints.XDSB_domain}/financial/fhir/InsurancePlan`;

  // Construir parâmetros de query apenas se não for busca por ID específico
  const queryParams: string[] = [];

  // Adicionar parâmetros válidos ao array

  if (count) queryParams.push(`_count=${count}`);
  if (status !== undefined) queryParams.push(`status=${status}`);
  if (ownedBy) queryParams.push(`owned-by=${encodeURIComponent(ownedBy)}`);
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);

  // Concatenar parâmetros com '&' se houver algum
  if (queryParams.length > 0) {
    url = `${url}?${queryParams.join("&")}`;
  }
  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetInsurancePlan: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetInsurancePlan ", error);
      // toast.error(`GetInsurancePlan Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
